<template>
    <UserBase>
        <div slot="content" class="page-user-profile">
            <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'โปรไฟล์ - ProbPlus', 
                'Profile - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'ข้อมูลการใช้งานส่วนตัวบนเว็บไซต์',
                'Trainee Profile')" />
            <ContentLoader :isDisplay="!contentReady" />
            <template v-if="contentReady">
                <h1><span>{{ $PPlusEngine.getDictionary($route.params.lang, 'ข้อมูลทั่วไป', 'My Profile') }}</span></h1>
                <div class="user-status">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'สถานะการรับรอง', 'Certified Status') }}</label>
                            <span :class="{ 
                                'green' : fields.profile.examStatus == $PPlusConstant.ExamStatus_PassExam, 
                                'red' : fields.profile.examStatus == $PPlusConstant.ExamStatus_PendingExam, 
                                'blue' : fields.profile.examStatus == $PPlusConstant.ExamStatus_PendingClass
                            }">
                                {{ fields.profile.examStatusText }}
                            </span>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'สถานะการชำระเงิน', 'Payment Status') }}</label>
                            <span :class="{ 
                                'green' : fields.profile.paymentStatus == $PPlusConstant.PaymentStatus_Paid, 
                                'blue' : fields.profile.paymentStatus == $PPlusConstant.PaymentStatus_WaitForConfirm, 
                                'red' : fields.profile.paymentStatus == $PPlusConstant.PaymentStatus_None
                                    || fields.profile.paymentStatus == $PPlusConstant.PaymentStatus_NeedPayExam
                            }">
                                {{ fields.profile.paymentStatusText }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="box">
                    <i class="pe-7s-user"></i>
                    <h4>
                        <font-awesome-icon :icon="['fas', 'user']" />
                        {{ $PPlusEngine.getDictionary($route.params.lang, 'ชื่อ - นามสกุล', 'Full Name') }}
                    </h4>
                    <div class="display">
                        {{ fields.profile.firstName }} {{ fields.profile.lastName }}
                    </div>    
                </div>
                <div class="box">
                    <i class="pe-7s-id"></i>
                    <h4>
                        <font-awesome-icon :icon="['fas', 'user']" />
                        {{ $PPlusEngine.getDictionary($route.params.lang, 'เลขบัตรประชาชน', 'Personal ID') }}
                    </h4>
                    <div class="display">
                        {{ fields.profile.personalID }}
                    </div>
                </div>
                <h2><span>{{ $PPlusEngine.getDictionary($route.params.lang, 'ประวัติการเข้าเรียน', 'Attendance History') }}</span></h2>
                <div class="module" v-for="(course, courseIndex) in fields.courseStatus" :key="courseIndex">
                    <h3><span>Module {{ course.moduleNumber }}</span> {{ course.moduleTitle }}</h3>
                    <div class="chapter">
                        {{ $PPlusEngine.getDictionary($route.params.lang, 'สถานะดาวน์โหลดเอกสารบังคับอ่าน', 'Download Required Materials Status') }}
                        <div class="status done" v-if="course.materialStatus">{{ $PPlusEngine.getDictionary($route.params.lang, 'อ่านครบแล้ว', 'Completed') }}</div>
                        <div class="status material" v-if="!course.materialStatus">{{ $PPlusEngine.getDictionary($route.params.lang, 'อ่านยังไม่ครบ', 'Not Completed') }}</div>
                    </div>
                    <router-link :to="'/' + $route.params.lang + '/course/' + course.moduleNumber + '/' + chapter.chapterNumber" class="chapter" v-for="(chapter, chapterIndex) in course.chapterList" :key="chapterIndex">
                        Chapter {{ chapter.chapterNumber }}: {{ chapter.chapterTitle }}
                        <div class="status done" v-if="chapter.chapterStatus">{{ $PPlusEngine.getDictionary($route.params.lang, 'เรียนจบแล้ว', 'Attended') }}</div>
                        <div class="status" v-if="!chapter.chapterStatus">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังเรียนไม่จบบท', 'No Attendance') }}</div>
                    </router-link>
                </div>
                <h2><span>{{ $PPlusEngine.getDictionary($route.params.lang, 'ประวัติการสอบ', 'Exam History') }}</span></h2>
                <div class="row">
                    <div class="col-sm-12 col-md-6" v-for="(item, index) in fields.examHistory" :key="index">
                        <div class="exam-result">
                            <div class="item">
                                <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'สอบครั้งที่', 'Exam Round') }}</label>
                                <span>{{ item.attemp }}</span>
                            </div>
                            <div class="item">
                                <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'คะแนนที่ได้', 'Score') }}</label>
                                <span>{{ item.score }}</span>
                            </div>
                            <div class="item">
                                <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'คะแนนเต็ม', 'Maximum') }}</label>
                                <span>{{ item.max }}</span>
                            </div>
                            <div class="item">
                                <label>{{ $PPlusEngine.getDictionary($route.params.lang, '% ความถูกต้อง', '% Correct') }}</label>
                                <span>{{ item.percent }}%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </UserBase>
</template>

<script>
import UserBase from '@/pages/UserBase';
import ContentLoader from '@/weact/components/ContentLoader';

export default {
    components: {
        UserBase,
        ContentLoader
    },
    data() {
        return {
            contentReady: false,
            fields: {}
        }
    },
    created() {
        let page = this;
        
        setTimeout(function(){
            page.getContent();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {
                langCode: this.$route.params.lang
            };

            this.$WeHelper.postAPI(apiURL, '/api/user/get-profile-content', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                this.fields = response.data;
                this.contentReady = true;
            });
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-user-profile {
    h1, h2 {
        font-size: 22px;
        color: $mainColor;
        margin: 0 0 15px;
        border-bottom: 1px solid #eee;

        span {
            display: inline-block;
            margin-bottom: -1px;
            padding-bottom: 10px;
            border-bottom: 2px solid $mainColor;
        }
    }

    h2 {
        margin: 40px 0 30px;
    }

    .box {
        position: relative;
        border: 1px dashed #ddd;
        padding: 25px;
        margin-top: 25px;
        overflow: hidden;

        i {
            position: absolute;
            right: 20px;
            top: 20px;
            font-size: 82px;
            color: #f2f2f2;
        }

        h4 {
            margin: 0;
            padding-bottom: 20px;
            font-size: 14px;
            color: #666;

            &:after {
                content: " ";
                display: block;
                margin-top: 10px;
                width: 50px;
                height: 1px;
                background: #deacae;
            }

            svg {
                @include verticalAlign(baseline);
                margin-right: 5px;
                color: #ded7d7;
            }

            @media only screen and (max-width: $screenSmall) {
                margin-top: 20px;
            }
        }
    }

    .user-status {
        margin-top: 25px;

        label {
            @include verticalAlign(middle);
            font-size: 14px;
            margin: 0;
            color: #333;

            @media only screen and (max-width: $screenSmall) {
                margin: 8px 0;
                width: 120px;
            }
        }

        span {
            @include verticalAlign(middle);
            font-size: 14px;
            padding: 5px 10px;
            margin-left: 20px;
            color: #fff;

            @media only screen and (max-width: $screenSmall) {
                margin-left: 0;
            }

            &.red {
                background: #cc0000;
            }

            &.blue {
                background: #5eafe8;
            }

            &.green {
                background: #2fceb0;
            }
        }
    }

    .module {
        margin-top: 30px;
        padding-bottom: 15px;
        border-bottom: 1px solid #ddd;

        h3 {
            font-size: 14px;
            line-height: 26px;
            color: #9a7137;
            padding-bottom: 15px;
            margin: 0;

            span {
                @include verticalAlign(baseline);
                background: #968a79;
                color: #fff;
                font-size: 13px;
                line-height: normal;
                padding: 3px 10px;
                margin-right: 10px;
                border-radius: 1000px;
            }
        }

        .chapter {
            position: relative;
            display: block;
            font-size: 13px;
            color: #555;
            padding: 7px 90px 7px 0;
            border-bottom: 1px solid #eee;

            &:last-child {
                border-bottom: none;
            }

            .status {
                position: absolute;
                top: 5px;
                right: 0;
                display: block;
                font-size: 12px;
                color: #fff;
                padding: 3px 8px;
                background: #e26a6a;

                &.material {
                    background: #ffaa00;
                }

                &.done {
                    background: #4bc5a9;
                }
            }
        }
    }

    .exam-result {
        border: 1px solid #e9e9e9;
        padding: 20px;

        @media only screen and (max-width: $screenSmall) {
            margin-bottom: 10px;
            padding: 15px 10px;
        }

        .item {
            label {
                @include verticalAlign(middle);
                width: 130px;
                margin: 3px 0;
                font-size: 14px;
                padding-right: 15px;
                color: #000;
                text-align: right;
            }

            span {
                @include verticalAlign(middle);
                font-size: 14px;
                color: $mainColor;
            }
        }
    }
}
</style>